module.exports = __webpack_public_path__ + "img/29.cb98f3bf.jpg";